import React, { useState, useEffect, useRef } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";

import {
  getTrainers,
  getTrainerCategories,
  getTrainingProviders,
  downloadTrainerImportTemplate,
  importTrainersFromExcel,
} from "../../../../store/cpd/actions";
import { showSuccess, showError } from "../../../toastify";
import { CSVLink } from "react-csv";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import ReactPaginate from "react-paginate";

import TrainerFormDialog from "../components/TrainerFormDialog";
import PreviewTrainerDialog from "../components/PreviewTrainerDialog";

const Trainers = (props) => {
  useEffect(() => {
    document.title = "TMIS | CPD - Trainers";
  }, []);

  const {
    user,
    loading,
    trainers,
    getTrainers,
    getTrainerCategories,
    getTrainingProviders,
    downloadTrainerImportTemplate,
    importTrainersFromExcel,
  } = props;

  useEffect(() => {
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };

    getTrainers(query, setTotalRecods, setLoader);

    getTrainerCategories();
    // getTrainingProviders();
  }, [user?.selectedEntity, user?.selectedAcademicYear]);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [loader, setLoader] = useState(false);

  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10,
  );

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getTrainers(query, setTotalRecods, setLoader);
  };

  const { hasPermissions } = useRequiredAuth();

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };
      getTrainers(query, setTotalRecods, setLoader);
    }
  };

  const [showTrainerFormDialog, setShowTrainerFormDialog] = useState(false);
  const trainerImportInputRef = useRef(null);
  const [importReportOpen, setImportReportOpen] = useState(false);
  const [importReport, setImportReport] = useState({
    imported: 0,
    failed: [],
  });

  const refreshTrainerList = () => {
    getTrainers(
      {
        searchTerm,
        page: currentPage,
        size: itemPerPage,
      },
      setTotalRecods,
      setLoader,
    );
  };

  const handleTrainerImportFile = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    importTrainersFromExcel(file, (err, data) => {
      if (err) {
        showError(err);
        return;
      }
      refreshTrainerList();
      if (data.failed?.length) {
        setImportReport({
          imported: data.imported || 0,
          failed: data.failed,
        });
        setImportReportOpen(true);
      }
      if ((data.imported || 0) > 0) {
        showSuccess(
          `Imported ${data.imported} trainer${data.imported === 1 ? "" : "s"}`,
        );
      }
      if ((data.imported || 0) === 0 && !(data.failed?.length)) {
        showError("No data rows to import");
      }
    });
  };

  return (
    <>
      <div className="px-4 pt-2">
        <div className="border rounded">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar
              style={{
                minHeight: "0px",
                borderBottom: "3px solid #e9ecef",
              }}
              className=" my-0 py-1 bg-light"
            >
              <Typography
                variant="p"
                noWrap
                component="div"
                className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
              >
                <span className="text-dark">({totalRecods}) Trainers</span>

                <CSVLink
                  data={trainers}
                  filename={`Trainers.csv`}
                  className="hidden"
                  id="downloadBTN"
                  target="_blank"
                />
                {hasPermissions(["CPD_TRAINERS_DOWNLOAD"]) && (
                  <Tooltip title="Download">
                    <span className="ml-2">
                      <IconButton
                        size="small"
                        disabled={loading || !trainers.length}
                        className=" mr-1"
                        color="primary"
                        onClick={() =>
                          document.getElementById("downloadBTN").click()
                        }
                      >
                        <span className="material-icons">file_download</span>
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Typography>

              <Box sx={{ flexGrow: 1 }} />
              {hasPermissions(["CPD_TRAINERS_REGISTER"]) && (
                <>
                  <input
                    type="file"
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    ref={trainerImportInputRef}
                    className="d-none"
                    onChange={handleTrainerImportFile}
                  />
                  <Tooltip title="Download Excel template">
                    <Button
                      className="mr-2"
                      onClick={() => downloadTrainerImportTemplate()}
                      variant="outlined"
                      size="small"
                      color="primary"
                    >
                      <span className="material-icons mr-1">description</span>
                      Template
                    </Button>
                  </Tooltip>
                  <Tooltip title="Upload filled template (.xlsx)">
                    <Button
                      className="mr-2"
                      onClick={() => trainerImportInputRef.current?.click()}
                      variant="outlined"
                      size="small"
                      color="primary"
                    >
                      <span className="material-icons mr-1">upload_file</span>
                      Import Excel
                    </Button>
                  </Tooltip>
                  <Button
                    className="mr-2"
                    onClick={() => {
                      setShowTrainerFormDialog(true);
                    }}
                    variant="contained"
                    size="small"
                    disableElevation
                    color="primary"
                  >
                    <span className="material-icons">add</span>
                    New trainer
                  </Button>
                </>
              )}
              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  onSearch={onSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };

                      getTrainers(query, setTotalRecods, setLoader);
                    }
                  }}
                  placeholder="Search…"
                />
              </Box>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "0.5rem",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
              height: "59vh",
              overflowY: "auto",
            }}
            className="px-3"
          >
            {!!trainers.length && (
              <table className="table table-striped table-hover   fixTableHead">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col">RegNo</th>
                    <th scope="col">Provider</th>
                    <th scope="col">Names</th>
                    <th scope="col">NID Number</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col"></th>
                  </tr>
                </thead>

                <tbody>
                  {trainers.map((item) => (
                    <ItemCard
                      key={item.id}
                      item={item}
                      user={user}
                      loading={loading}
                    />
                  ))}
                </tbody>
              </table>
            )}

            {!trainers?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No record found"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
          {!!trainers.length && (
            <div
              className="d-flex justify-content-center  align-items-center"
              style={{ overflow: "hidden" }}
            >
              <>
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRecods / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                <select
                  className="custom-select custom-select-sm mr-3 ml-2"
                  style={{ width: "100px" }}
                  value={itemPerPage}
                  onChange={(event) => {
                    const itemPerPage = +event.target.value;
                    window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                    setItemPerPage(itemPerPage);
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };
                    getTrainers(query, setTotalRecods, setLoader);
                  }}
                >
                  {[10, 50, 100, 150].map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
              </>
            </div>
          )}
        </div>
      </div>

      {loader && (
        <CircularProgress
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "rgb(7, 142, 206)",
            position: "absolute",
            top: "42%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
          size={40}
          thickness={4}
        />
      )}

      {showTrainerFormDialog && (
        <TrainerFormDialog
          showDialog={showTrainerFormDialog}
          setShowDialog={setShowTrainerFormDialog}
          setTotalRecods={setTotalRecods}
          totalRecods={totalRecods}
        />
      )}

      <Dialog
        open={importReportOpen}
        onClose={() => setImportReportOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Import report</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" className="mb-2">
            Imported: {importReport.imported}. Rows with errors:{" "}
            {importReport.failed.length}.
          </Typography>
          <div
            style={{ maxHeight: 280, overflow: "auto" }}
            className="small text-muted"
          >
            {importReport.failed.slice(0, 50).map((f, i) => (
              <div key={`${f.row}-${i}`}>
                Row {f.row}: {f.message}
              </div>
            ))}
            {importReport.failed.length > 50 && (
              <div className="mt-1">…and more (see full response in network tab)</div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImportReportOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ user, loading, trainers }) => {
  return { user, loading, trainers };
};
export default connect(mapStateToProps, {
  getTrainers,
  getTrainerCategories,
  getTrainingProviders,
  downloadTrainerImportTemplate,
  importTrainersFromExcel,
})(Trainers);

const ItemCard = (props) => {
  const { loading, user, item } = props;

  const [showProvidersDialog, setShowProvidersDialog] = useState(false);
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <tr>
        <td className="text-left">{item.no}</td>
        <td className="text-left">
          <strong>{item.id}</strong>
        </td>
        <td className="text-left">{item.providerName}</td>

        <td className="text-left">
          {item.lastName} {item.firstName}
        </td>
        <td className="text-left">{item.nidNumber || item.passportNumber}</td>
        <td className="text-left">{item.email}</td>
        <td className="text-left">{item.phoneNumber}</td>

        <td className="text-right">
          <IconButton
            size="small"
            onClick={handleOpenMenu}
            aria-label="settings"
          >
            <Badge color="info">
              <span className="material-icons">more_horiz</span>
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <span>
              <MenuItem
                onClick={(e) => {
                  handleCloseMenu();
                  setShowPreviewDialog(true);
                }}
                className={`text-dark font-weight-bolder`}
              >
                <span className="material-icons  mr-1">open_in_new</span>
                Preview
              </MenuItem>
              <Divider className="my-1" />
            </span>

            {/* <span>
              <MenuItem
                onClick={(e) => {
                  handleCloseMenu();
                }}
                className="text-danger"
              >
                <span className="material-icons mr-1">
                  remove_circle_outline
                </span>
                Remove
              </MenuItem>
            </span> */}
          </Menu>
        </td>
      </tr>

      {showPreviewDialog && (
        <PreviewTrainerDialog
          showDialog={showPreviewDialog}
          setShowDialog={setShowPreviewDialog}
          trainer={item}
        />
      )}
    </>
  );
};
